// Absolute Y position a scroll to this element should land at. The element's
// CSS scroll-margin-top applies, so JS scrolls land exactly where a native
// hash jump would.
export const getScrollTargetY = (element) => {
  const scrollMargin = parseInt(window.getComputedStyle(element).scrollMarginTop, 10) || 0;
  return element.getBoundingClientRect().top + window.scrollY - scrollMargin;
};

// Scroll to an element by id. Returns false if the element doesn't exist.
export const scrollToElementId = (id, { behavior = "smooth" } = {}) => {
  const element = document.getElementById(id);
  if (!element) return false;

  window.scrollTo({ top: getScrollTargetY(element), behavior });
  return true;
};
